var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { padding: "40px 20px", "background-color": "#FFF" } },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12, xs: 24 } },
            [
              _c(
                "el-row",
                {
                  staticStyle: { display: "flex", "justify-content": "center" }
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "flex-centered", attrs: { span: 24 } },
                    [
                      _c("div", { staticClass: "icon-offset-new-property" }, [
                        _c("img", {
                          staticClass: "feature-icon",
                          attrs: {
                            loading: "lazy",
                            src: require("../../assets/brand-new-property-only.svg")
                          }
                        })
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "flex-centered font-title",
                      attrs: { span: 24 }
                    },
                    [_c("span", [_vm._v("Real Estate Built For You")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "flex-centered font-desc",
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Save time and money by exploring land and newly built homes for sale that have never been lived in"
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12, xs: 24 } },
            [
              _c(
                "el-row",
                {
                  staticStyle: { display: "flex", "justify-content": "center" }
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "flex-centered", attrs: { span: 24 } },
                    [
                      _c("div", { staticClass: "icon-offset-transparency" }, [
                        _c("img", {
                          staticClass: "feature-icon",
                          attrs: {
                            loading: "lazy",
                            src: require("../../assets/discover-with-transparency.svg")
                          }
                        })
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "flex-centered font-title",
                      attrs: { span: 24 }
                    },
                    [_c("span", [_vm._v("Explore Every Detail")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "flex-centered font-desc",
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "With more real estate information than any other platform, you can analyse every aspect before you decide"
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            {
              staticStyle: { "padding-top": "30px" },
              attrs: { span: 12, xs: 24 }
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { display: "flex", "justify-content": "center" }
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "flex-centered", attrs: { span: 24 } },
                    [
                      _c("div", { staticClass: "icon-offset-buy-online" }, [
                        _c("img", {
                          staticClass: "feature-icon",
                          attrs: {
                            loading: "lazy",
                            src: require("../../assets/buy-online.svg")
                          }
                        })
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "flex-centered font-title",
                      attrs: { span: 24 }
                    },
                    [_c("span", [_vm._v("Enquire and Select Online")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "flex-centered font-desc",
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Contact the agent or begin the buying process by selecting your preferred property online"
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticStyle: { "padding-top": "30px" },
              attrs: { span: 12, xs: 24 }
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { display: "flex", "justify-content": "center" }
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "flex-centered", attrs: { span: 24 } },
                    [
                      _c("div", { staticClass: "icon-offset-price-list" }, [
                        _c("img", {
                          staticClass: "feature-icon",
                          attrs: {
                            loading: "lazy",
                            src: require("../../assets/live-pricelist.svg")
                          }
                        })
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "flex-centered font-title",
                      attrs: { span: 24 }
                    },
                    [_c("span", [_vm._v("Live Pricing with No Surprises")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "flex-centered font-desc",
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "Pricing, availability and associated fees are available for every project, so you know the costs involved with buying your next home"
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79ad8b2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79ad8b2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/propertyIconSet.vue
// module id = null
// module chunks = 